import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a7724e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "text-center" }

import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import AvatarUpload from "@/components/AvatarUpload.vue";
import { useGroupStore } from "@/store/groupStore";
import { useRouter } from "vue-router";
import { reactive, ref, toRefs } from "vue";
import GroupApi from "@/api/GroupApi";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";

interface VimData {
  host: string;
  headers: any;
  data: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'New',
  setup(__props) {

const router = useRouter();
const groupStore = useGroupStore();
const ruleFormRef = ref<InstanceType<typeof ElForm>>();

const dataForm = reactive({
  name: "",
  needCheck: false,
  avatar: "/img/default-group.png",
});

const rules = reactive({
  name: [
    {
      required: true,
      message: "必填",
      trigger: "blur",
    },
    {
      min: 3,
      max: 10,
      message: "长度介于3-10",
      trigger: "blur",
    },
  ],
});

const uploadSuccess = (url: string) => {
  dataForm.avatar = url;
};

const vimData = reactive<VimData>({
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
  data: {
    access_token: Auth.getToken(),
    type: "file",
  },
});

const saveGroup = () => {
  ruleFormRef.value?.validate((f) => {
    if (f) {
      GroupApi.save(
        dataForm.name,
        dataForm.avatar,
        dataForm.needCheck ? "1" : "0"
      )
        .then((res) => {
          groupStore.checkIndex = groupStore.groupList.length;
          groupStore.reloadGroupList().then(() => {
            router.push("/index/group/" + res.data.id);
          });
          ElMessage.success("保存成功");
        })
        .catch(() => {
          ElMessage.error("保存错误");
        });
    }
  });
};

const { host, headers, data } = toRefs(vimData);

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AvatarUpload, {
        avatar: dataForm.avatar,
        onUploadSuccess: uploadSuccess
      }, null, 8, ["avatar"])
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: dataForm,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "群名称:",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: dataForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveGroup
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ], 64))
}
}

})